export const SET_BEITRAG_STATI = "setBeitragStati";
export const SET_BEITRAG_INTERVALLE = "setBeitragsIntervalle";
export const SET_ANTRAGS_STATI = "setAntragsStati";
export const SET_ABRECHNUNGS_STATI = "setAbrechnungsStati";
export const SET_ABRECHNUNGS_PERIODEN = "setAbrechnungsPerioden";
